/* eslint-disable max-len */
var ICON_UI_MINUS = {
  v2: true,
  "default": 'M0.75 12.038H23.25',
  globetrotter: 'M1.875 12H22.125'
};

export { ICON_UI_MINUS };
//# sourceMappingURL=ICON_UI_MINUS.js.map
